export const ORDER_NORMALIZE_FACTOR = 10;
